import {useDownloadFile} from 'hooks/use-download-file/use-download-file';
import {FC, memo, useCallback} from 'react';
import {userClient} from 'state/api-clients';
import {AsyncOperationHandler} from 'utilities/platform-helpers/api-helper';
import {YYMMDDhhmm} from 'utilities/platform-helpers/date-helpers';
import {DownloadExcelButton} from 'view/components/specific-components/buttons/download-excel-button';

export const DownloadUserExcel: FC = memo(() => {
  const exportUserOverview = useCallback(async () => {
    return await AsyncOperationHandler(() => userClient.exportUserOverview());
  }, []);

  const namePostfix = () => {
    return `-${YYMMDDhhmm(new Date())}`;
  };

  const {ref, url, download, name, isLoading} = useDownloadFile({
    apiDefinition: exportUserOverview,
    namePostfix: namePostfix,
  });

  return <DownloadExcelButton isLoading={isLoading} name={name} url={url} download={download} reference={ref} />;
});
